import { render, staticRenderFns } from "./AddNewStatusEvent.vue?vue&type=template&id=20f3b74a&scoped=true"
import script from "./AddNewStatusEvent.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddNewStatusEvent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AddNewStatusEvent.vue?vue&type=style&index=0&id=20f3b74a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f3b74a",
  null
  
)

export default component.exports